/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';

const displayName = 'DetailInvoiceDraft';
const propTypes = {};
const defaultProps = {}

export default { displayName, propTypes, defaultProps };
